var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1412 5.66211C11.9809 5.66211 9.90899 6.5203 8.3814 8.0479C6.8538 9.5755 5.99561 11.6474 5.99561 13.8077C5.99561 15.9681 6.8538 18.0399 8.3814 19.5675C9.90899 21.0951 11.9809 21.9533 14.1412 21.9533C15.5308 21.9533 16.8838 21.5982 18.0789 20.9383L19.8123 22.6748C20.694 23.5582 22.125 23.5594 23.0083 22.6777C23.8917 21.7959 23.8929 20.365 23.0112 19.4816L21.274 17.7414C21.9325 16.5473 22.2868 15.1958 22.2868 13.8077C22.2868 11.6474 21.4286 9.5755 19.901 8.0479C18.3734 6.5203 16.3015 5.66211 14.1412 5.66211ZM11.5775 11.244C12.2574 10.564 13.1796 10.182 14.1412 10.182C15.1028 10.182 16.025 10.564 16.705 11.244C17.3849 11.9239 17.7669 12.8461 17.7669 13.8077C17.7669 14.7573 17.3943 15.6686 16.7302 16.346L16.7089 16.367C16.7001 16.3757 16.6915 16.3845 16.6829 16.3933C16.0051 17.0596 15.0924 17.4334 14.1412 17.4334C13.1796 17.4334 12.2574 17.0514 11.5775 16.3715C10.8975 15.6915 10.5155 14.7693 10.5155 13.8077C10.5155 12.8461 10.8975 11.9239 11.5775 11.244Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.4e6a1f9a883d7476aa367b9d6d4cc369.svg";
export { ForwardRef as ReactComponent };